import { ShowBase, useShowContext } from "ra-core";
import type { ShowBaseProps } from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";

import MobileHeader from "../layout/MobileHeader";
import { MobileContent } from "../layout/MobileContent";
import { BriefIABanner } from "./BriefIABanner";
import { ContactHeader } from "./ContactHeader";
import { ContactTabs } from "./ContactTabs";
import { MobileBackButton } from "../misc/MobileBackButton";
import type { Contact } from "../types";

export const ContactShow = (props: ShowBaseProps = {}) => {
  const isMobile = useIsMobile();

  return (
    <ShowBase
      queryOptions={{
        onError: isMobile
          ? () => {
              {
                /** Disable error notification as the content handles offline */
              }
            }
          : undefined,
      }}
      {...props}
    >
      {isMobile ? <ContactShowContentMobile /> : <ContactShowContent />}
    </ShowBase>
  );
};

/**
 * Sprint 2 · T2.3.b — Unification mobile. ContactShowContentMobile partage
 * désormais les mêmes ContactHeader + ContactTabs que desktop. Le
 * MobileHeader sticky garde uniquement le BackButton (le Edit du contact
 * est désormais accessible via le menu "..." du ContactHeader, T2.2).
 */
const ContactShowContentMobile = () => {
  const { record, isPending } = useShowContext<Contact>();
  if (isPending || !record) return null;

  return (
    <>
      <MobileHeader>
        <MobileBackButton />
      </MobileHeader>
      <MobileContent>
        <div className="flex flex-col gap-4">
          <ContactHeader />
          <BriefIABanner />
          <ContactTabs />
        </div>
      </MobileContent>
    </>
  );
};

const ContactShowContent = () => {
  const { record, isPending } = useShowContext<Contact>();
  if (isPending || !record) return null;

  return (
    <div className="flex flex-col gap-4">
      {/* Sprint 2 — Header enrichi (population, température, prochaine action,
          marquer fait, menu d'actions). Cf design/atomic-crm/header.jsx. */}
      <ContactHeader />

      {/* Sprint 2 · T2.7 — BriefIABanner. Placé entre header et onglets,
          autonome via useRecordContext, alimenté par la skill brief_pre_call. */}
      <BriefIABanner />

      {/* Sprint 2 · T2.3 — 5 onglets (Timeline / Activité / Paiements / Tâches /
          Détails). ContactAside éliminée (cf SPRINT_2_AUDIT.md §9.1).
          NOTE : `ContactAside.tsx` et `AsideSection.tsx` restent dans le repo
          comme dead code candidates pour un sprint cleanup futur (T2.4+ ou
          dédié). Pas supprimés maintenant pour éviter une PR fleuve. */}
      <ContactTabs />
    </div>
  );
};
